import { render, staticRenderFns } from "./3DCar.vue?vue&type=template&id=1d2e0ea9&scoped=true&"
import script from "./3DCar.vue?vue&type=script&lang=js&"
export * from "./3DCar.vue?vue&type=script&lang=js&"
import style0 from "./3DCar.vue?vue&type=style&index=0&id=1d2e0ea9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2e0ea9",
  null
  
)

export default component.exports